import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type BaseUserDataObject } from 'models/service';

// TODO change type when needed
// TODO this belongs somewhere else
export const getUser = async (userId: string) =>
  apiClient.get<BaseUserDataObject, ApiClientResponse<any>>(routes.user.get(userId));
